import React from 'react';
import type { LucideIcon } from 'lucide-react';

export interface PropsWithChildren {
  children: React.ReactNode;
  className?: string;
}

export interface PropsWithI18nMessages {
  // Translation dictionaries are free-form JSON (en.json / zh.json), read with optional chaining
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  i18nMessages?: Record<string, any>;
}

export type Option = {
  label: string | React.ReactNode;
  value: string | number;
  href?: string;
  icon?: string;
};

export enum Status {
  Active = 'active',
  Inactive = 'inactive',
}

export type IMenu = {
  title: string;
  i18nKey: string;
  icon: LucideIcon;
  href: string;
  subMenus?: IMenu[];
};

export enum StyleVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Danger = 'danger',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Highlight = 'highlight',
  Default = '',
}
